import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import UnexpectedError from "shared/UnexpectedError";

import { useTranslation } from "react-i18next";
import { importLangResources } from "locale";

const ErrorMessage = ({ errorMessage }) => {
  const { t } = useTranslation();
  const [, setReady] = useState(0);

  useEffect(() => {
    importLangResources("generic").then(() => setReady(x => x + 1));
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };
  return (
    <div
      style={{ height: "100vh" }}
      className="d-flex flex-column align-items-center justify-content-center"
    >
      <UnexpectedError errorMessage={errorMessage} />
      <div className="d-flex justify-content-center">
        <button className="btn btn-primary me-2" onClick={handleRefresh}>
          {t("generic:buttons.refresh")}
        </button>
        <a className="btn btn-primary" href="/logout">
          {t("generic:buttons.logout")}
        </a>
      </div>
    </div>
  );
};

ErrorMessage.propTypes = {
  errorMessage: PropTypes.string
};

export default ErrorMessage;
